export default "__VITE_PUBLIC_ASSET__a94b2ce8__"